import '../../base/style/css.mjs';
import '../../badge/style/css.mjs';
import 'element-plus/theme-chalk/el-message.css';
//# sourceMappingURL=css.mjs.map
